import { GridFilterInputBoolean } from "../components/panel/filterPanel/GridFilterInputBoolean.es.js";
import { convertLegacyOperators } from "./utils.es.js";
const getGridBooleanOperators = () => convertLegacyOperators([{
  value: "is",
  getApplyFilterFnV7: (filterItem) => {
    if (!filterItem.value) {
      return null;
    }
    const valueAsBoolean = filterItem.value === "true";
    return (value) => {
      return Boolean(value) === valueAsBoolean;
    };
  },
  InputComponent: GridFilterInputBoolean
}]);
export {
  getGridBooleanOperators
};
//# sourceMappingURL=gridBooleanOperators.es.js.map
